/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
export default {
  name: "ManageSDVRule",
  props: {
    editingId: { type: String, default: null },
    planId: { type: String, required: true },
    planVersion: { type: Number, default: 0 },
    viewMode: { type: Boolean, default: false },
  },
  
  components: {
    customModal,
  },
  data() {
    return {
      token: "",
      baseurl: process.env.VUE_APP_Service_URL,
      isEditMode: false,
      isSubmitting: false,
      studyRef: "",

      rule: {
        ruleName: "",
        ruleType: "",
        ruleNo: "",
        triggerType: "",
        triggerEvent: "",
        priority: 0,
        formId: "",
        formName: "",
        fieldName: "",
        fieldLabel: "",
        sdvPercentage: 0,
        sequenceCount: null,
        status: "Active",
        applyTo: "SelectedSites" // default
      },

      // ---- form & fields ----
      selectedFields: [],
      triggerConditions: [],
      conditionDraft: "",
      formList: [],
      formsLoading: false,
      formSearch: "",
      formDropdownOpen: false,
      selectedForm: null,
      availableFields: [],
      fieldsLoading: false,
      fieldSearch: "",

      // ---- visits ----
      visitList: [],
      visitsLoading: false,
      visitSearch: "",
      visitDropdownOpen: false,
      selectedVisits: [],

      // ---- sites ----
      siteList: [],
      sitesLoading: false,
      siteSearch: "",
      siteDropdownOpen: false,
      selectedSites: [],

      // ---- subject ----
      subjectInput: "",

      // ---- static options ----
      ruleTypeOptions: [
        { value: "Full", label: "Full", desc: "Verify 100% of data points in scope" },
        { value: "Targeted SDV", label: "Targeted SDV", desc: "Only predefined critical data are verified" },
        { value: "Percentage", label: "Percentage", desc: "Verify a set % of matching data" },
        { value: "Sequential", label: "Sequential", desc: "Verifies records in the order they are entered until the configured SDV target is met." },
      
      ],
      triggerTypeOptions: ["Data Entry", "Event-Based"],
      triggerEventOptions: ["OnSave", "OnComplete"],

      errors: {},
      errorMessages: {}
    };
  },
  

  computed: {
    filteredForms() {
      const q = this.formSearch.trim().toLowerCase();
      if (!q) return this.formList;
      return this.formList.filter(t =>
        (t.templateName || "").toLowerCase().includes(q)
      );
    },
    filteredFields() {
      const q = this.fieldSearch.trim().toLowerCase();
      if (!q) return this.availableFields;
      return this.availableFields.filter(
        f =>
          (f.label || "").toLowerCase().includes(q) ||
          (f.fieldName || "").toLowerCase().includes(q)
      );
    },
    filteredVisits() {
      const q = this.visitSearch.trim().toLowerCase();
      if (!q) return this.visitList;
      return this.visitList.filter(v =>
        (v.visitFormName || "").toLowerCase().includes(q)
      );
    },
    filteredSites() {
      const q = this.siteSearch.trim().toLowerCase();
      if (!q) return this.siteList;
      return this.siteList.filter(s =>
        (s.siteCode || "").toLowerCase().includes(q) ||
        (s.siteName || "").toLowerCase().includes(q)
      );
    },
    isPercentageLocked() {
      return this.rule.ruleType === "Full" || this.rule.ruleType === "None";
    },
    allSitesSelected() {
      return this.siteList.length > 0 && this.selectedSites.length === this.siteList.length;
    }
  },
 async mounted() {
  this.token = store.getters.getIdToken;
  document.addEventListener("mousedown", this.handleOutsideClick);

  const studyId = store.getters.getStudyIs;
  if (!this.editingId) {
    this.rule.triggerType = "Data Entry";
  }
  if (this.editingId) {
    this.isEditMode = true;
    await this.loadRule(this.editingId); 
  }
  if (studyId) {
    await Promise.all([
      this.loadForms(),
      this.getVisits(studyId),            
      this.getSites(studyId)               
    ]);
  }
  await this.getStudyDetails();
},

  beforeDestroy() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  },

  methods: {
    authHeaders() {
      return {
        headers: {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json"
        }
      };
    },

    /* ---------------- form picker ---------------- */
    async loadForms() {
      this.formsLoading = true;
      try {
        const res = await axios.get(
          `${this.baseurl}/forms/template/listtemplate?IsPrivileged=false&Status=Approved&StudyID=${store.getters.getStudyIs}&SortProperty=templateName`,
          this.authHeaders()
        );
        this.formList = (res.data && res.data.results) || [];
      } catch (err) {
        console.error("Error loading form templates:", err);
        this.formList = [];
      } finally {
        this.formsLoading = false;
      }
    },

    async selectForm(template) {
      this.selectedForm = template;
      this.rule.formId = template.templateId;
      this.rule.formName = (template.templateName || "").trim();
      this.formDropdownOpen = false;
      this.formSearch = "";
      this.selectedFields = [];
      this.rule.fieldName = "";
      this.rule.fieldLabel = "";
      await this.loadFields(template.templateId);
        if (this.rule.ruleType === "Full") {
    this.selectAllFields();
  }
    },
    

    clearForm() {
      this.selectedForm = null;
      this.rule.formId = "";
      this.rule.formName = "";
      this.availableFields = [];
      this.selectedFields = [];
      this.rule.fieldName = "";
      this.rule.fieldLabel = "";
    },

    handleOutsideClick(e) {
      const formPicker = this.$refs.formPicker;
      const visitPicker = this.$refs.visitPicker;
      const sitePicker = this.$refs.sitePicker;
      if (formPicker && !formPicker.contains(e.target)) this.formDropdownOpen = false;
      if (visitPicker && !visitPicker.contains(e.target)) this.visitDropdownOpen = false;
      if (sitePicker && !sitePicker.contains(e.target)) this.siteDropdownOpen = false;
    },

    /* ---------------- field picker ---------------- */
    async loadFields(templateId) {
      this.fieldsLoading = true;
      this.availableFields = [];
      try {
        const res = await axios.get(
          `${this.baseurl}/forms/template/get/${templateId}`,
          this.authHeaders()
        );
        const pages = (res.data && res.data.pages) || [];
        const flat = [];
        pages.forEach(page => {
          (page.field || []).forEach(field => {
            if (
              field.type !== "header" &&
              field.type !== "subHeader" &&
              field.type !== "repeatingfield" &&
              field.fieldName
            ) {
              flat.push(field);
            }
            if (field.type === "repeatingfield" && Array.isArray(field.repeatingFields)) {
              field.repeatingFields.forEach(repField => {
                if (repField.fieldName) flat.push(repField);
              });
            }
          });
        });
        this.availableFields = flat;
      } catch (err) {
        console.error("Error loading template fields:", err);
      } finally {
        this.fieldsLoading = false;
      }
    },

    toggleField(fieldName) {
      const i = this.selectedFields.indexOf(fieldName);
      if (i === -1) this.selectedFields.push(fieldName);
      else this.selectedFields.splice(i, 1);
      this.syncPrimaryField();
    },

    selectAllFields() {
      this.selectedFields = this.availableFields.map(f => f.fieldName);
      this.syncPrimaryField();
    },

    clearFields() {
      this.selectedFields = [];
      this.syncPrimaryField();
    },

    syncPrimaryField() {
      const first = this.availableFields.find(
        f => f.fieldName === this.selectedFields[0]
      );
      this.rule.fieldName = first ? first.fieldName : "";
      this.rule.fieldLabel = first ? first.label : "";
    },

    /* ---------------- chip inputs ---------------- */
    addCondition() {
      const c = this.conditionDraft.trim().replace(/,+$/, "");
      if (c && !this.triggerConditions.includes(c)) this.triggerConditions.push(c);
      this.conditionDraft = "";
    },
    removeCondition(c) {
      this.triggerConditions = this.triggerConditions.filter(x => x !== c);
    },
    onConditionKeydown(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        this.addCondition();
      }
    },

    /* ---------------- rule type / percentage ---------------- */
    setRuleType(value) {
  const previousType = this.rule.ruleType;
  this.rule.ruleType = value;

  // Handle percentage/slider defaults
  if (value === "Full") {
    this.rule.sdvPercentage = 100;
    // If a form is already loaded, auto‑select all fields
    if (this.availableFields.length) {
      this.selectAllFields();
    }
  } else {
    if (value === "None") this.rule.sdvPercentage = 0;
    if (previousType !== value) {
      this.clearForm();
    }
  }
},
  //   setRuleType(value) {
  //     this.rule.ruleType = value;
  //     if (value === "Full") this.rule.sdvPercentage = 100;
  //     if (value === "None") this.rule.sdvPercentage = 0;
  //     if (value === "Full" && this.availableFields.length) {
  //   this.selectAllFields();
  // }
  //   },
    setTriggerType(value) {
  // Toggle: if already active, set to empty to deactivate
  this.rule.triggerType = this.rule.triggerType === value ? "" : value;

  // Clear event and conditions if we are not in Event-Based mode
  if (this.rule.triggerType !== "Event-Based") {
    this.rule.triggerEvent = "";
    this.triggerConditions = [];
  }
},

    // setTriggerType(value) {
    //   this.rule.triggerType = this.rule.triggerType === value ? "" : value;
    //   if (this.rule.triggerType !== "Event-Based") {
    //     this.rule.triggerEvent = "";
    //   }
    //   if (this.rule.triggerType !== "Data Entry") {
    //     this.triggerConditions = [];
    //   }
    // },

    /* ---------------- visits ---------------- */
    async getVisits(studyId) {
      this.visitsLoading = true;
      try {
        const res = await axios.get(
          `${this.baseurl}/management/visit/listvisit?StudyId=${studyId}&pageindex=1&pagesize=9999&SortProperty=visitNo&ConvertToNumeric=true&SortOrder=0`,
          this.authHeaders()
        );
        this.visitList = (res.data && res.data.results) || [];
      } catch (err) {
        console.error("Error loading visits:", err);
        this.visitList = [];
      } finally {
        this.visitsLoading = false;
      }
    },

    toggleVisit(visitId) {
      const idx = this.selectedVisits.indexOf(visitId);
      if (idx > -1) this.selectedVisits.splice(idx, 1);
      else this.selectedVisits.push(visitId);
    },

    getVisitName(visitId) {
      const v = this.visitList.find(item => item.visitId === visitId);
      return v ? v.visitFormName : visitId;
    },

    /* ---------------- sites ---------------- */
    async getSites(studyId) {
      this.sitesLoading = true;
      try {
        const res = await axios.get(
          `${this.baseurl}/management/site/getallsitesbyuser?studyId=${studyId}&sortProperty=siteCode&IsDes=false&getAll=true`,
          this.authHeaders()
        );
        // Normalize: ensure each site has a siteId
        this.siteList = (res.data || []).map(s => ({
          ...s,
          siteId: s.siteID
        }));
      } catch (err) {
        console.error("Error loading sites:", err);
        this.siteList = [];
      } finally {
        this.sitesLoading = false;
      }
    },

    toggleSite(siteId) {
      const idx = this.selectedSites.indexOf(siteId);
      if (idx > -1) this.selectedSites.splice(idx, 1);
      else this.selectedSites.push(siteId);
      this.updateApplyTo();
    },

    selectAllSites() {
      this.selectedSites = this.siteList.map(s => s.siteId);
      this.rule.applyTo = "AllSites";
    },

    clearAllSites() {
      this.selectedSites = [];
      this.rule.applyTo = "SelectedSites";
    },

    getSiteName(siteId) {
      const s = this.siteList.find(item => item.siteId === siteId);
      return s ? `${s.siteCode} – ${s.siteName}` : siteId;
    },

    updateApplyTo() {
      // Determine applyTo based on current selection
      this.rule.applyTo = (this.siteList.length && this.selectedSites.length === this.siteList.length)
        ? "AllSites"
        : "SelectedSites";
    },

    toggleAllSites() {
      if (this.allSitesSelected) {
        this.selectedSites = [];
      } else {
        this.selectedSites = this.siteList.map(s => s.siteId);
      }
    },

    /* ---------------- load / save ---------------- */
async loadRule(id) {
  try {
    const res = await axios.get(
      `${this.baseurl}/management/sdv/getsdvplanrulebyid?id=${id}`,
      this.authHeaders()
    );
    const data = res.data;

    const firstField = data.fields && data.fields[0];
    const loadedFieldName = (firstField && typeof firstField === "object")
      ? (firstField.fieldName || "")
      : (data.fieldName || "");
    const loadedFieldLabel = (firstField && typeof firstField === "object")
      ? (firstField.label || "")
      : (data.label || "");

    // Populate rule object
    this.rule = {
      ruleName: data.ruleName || "",
      ruleNo: data.ruleNo || "",
      ruleType: data.ruleType || "",
      triggerType: data.triggerType || "",
      triggerEvent: data.triggerEvent || "",
      priority: data.priority || 0,
      formId: data.formId || "",
      formName: data.formName || "",
      fieldName: loadedFieldName,
      fieldLabel: loadedFieldLabel,
      sdvPercentage: data.sdvPercentage || 0,
      sequenceCount: data.sequenceCount || null,
      status: data.status || "Active",
      applyTo: data.applyTo || "SelectedSites"
    };

    // Restore selected fields
    if (data.fields && Array.isArray(data.fields)) {
      this.selectedFields = data.fields.map(f => {
        if (f && typeof f === "object" && f.fieldName) return f.fieldName;
        return f;
      });
    } else {
      this.selectedFields = [];
    }

    // Restore trigger conditions, visits, sites
    this.triggerConditions = data.triggerConditions || [];
    this.selectedVisits = data.visitIds || [];
    this.selectedSites = data.siteIds || [];

    // If applyTo is AllSites, select all sites (only if siteList is populated)
    if (this.rule.applyTo === "AllSites" && this.siteList.length) {
      this.selectedSites = this.siteList.map(s => s.siteId);
    }

    // Restore subject IDs
    if (data.subjectId && Array.isArray(data.subjectId)) {
      this.subjectInput = data.subjectId.join(', ');
    } else {
      this.subjectInput = '';
    }

    // Restore the selected form and load its fields
    if (this.rule.formId) {
      this.selectedForm =
        this.formList.find(t => t.templateId === this.rule.formId) || {
          templateId: this.rule.formId,
          templateName: this.rule.formName,
          version: "",
          status: ""
        };
      await this.loadFields(this.rule.formId);

      // ★ NEW: If rule type is Full, auto‑select all fields
      if (this.rule.ruleType === "Full" && this.availableFields.length) {
        this.selectAllFields();
      }
    }
  } catch (err) {
    console.error("Error loading rule:", err);
    alert("Failed to load rule details.");
  }
},

    validate() {
      this.errors = {};
      this.errorMessages = {};
      let ok = true;

      if (!this.rule.ruleName.trim()) {
        this.errors.ruleName = true;
        this.errorMessages.ruleName = "Please enter a rule name";
        ok = false;
      }
      if (!this.rule.ruleType) {
        this.errors.ruleType = true;
        this.errorMessages.ruleType = "Please choose a rule type";
        ok = false;
      }
      if (this.rule.ruleType === 'Sequential') {
  if (!this.rule.sequenceCount || this.rule.sequenceCount < 1) {
    this.errors.sequenceCount = true;
    this.errorMessages.sequenceCount = 'Please enter a positive number for Sequence Count';
    ok = false;
  }
}
      if (!this.rule.formId) {
        this.errors.formId = true;
        this.errorMessages.formId = "Please select a form";
        ok = false;
      }
      if (this.selectedFields.length === 0) {
        this.errors.fields = true;
        this.errorMessages.fields = "Select at least one field to verify";
        ok = false;
      }
      if (this.rule.ruleNo && !/^\d+$/.test(this.rule.ruleNo)) {
        this.errors.ruleNo = true;
        this.errorMessages.ruleNo = "Rule No must contain only numbers";
        ok = false;
      }
      return ok;
    },
    async submitRule() {
      if (!this.validate()) return;

      const subjectArray = this.subjectInput
        .split(',')
        .map(s => s.trim())
        .filter(s => s !== '');

      const applyTo = this.allSitesSelected ? "AllSites" : "SelectedSites";

      // Base payload (common to both create and update)
      const basePayload = {
        studyId: store.getters.getStudyIs,
        studyRef: this.studyRef,
        planId: this.planId,
        planVersion: this.planVersion,
        ruleNo: this.rule.ruleNo,
        ruleName: this.rule.ruleName,
        ruleType: this.rule.ruleType,
        sequenceCount: this.rule.ruleType === 'Sequential' ? this.rule.sequenceCount : null,
        triggerType: this.rule.triggerType,
        triggerEvent: this.rule.triggerEvent,
        priority: this.rule.priority,
        formId: this.rule.formId,
        formName: this.rule.formName,
        applyTo: applyTo,
        fields: this.selectedFields.map(f => {
          const field = this.availableFields.find(x => x.fieldName === f);
          return {
            fieldName: f,
            label: field ? field.label : ""
          };
        }),
        siteIds: this.selectedSites,
        visitIds: this.selectedVisits,
        subjectId: subjectArray,
        triggerConditions: this.triggerConditions,
        sdvPercentage: this.rule.sdvPercentage,
        status: this.rule.status
      };
      this.isSubmitting = true;

      try {
        let url, method;
        if (this.isEditMode) {
          // For update, add the 'id' field
          const payload = { ...basePayload, id: this.editingId };
          url = `${this.baseurl}/management/sdv/updatesdvplanrule`;
          method = axios.put;
          await method(url, payload, this.authHeaders());
          alert("Rule updated successfully");
        } else {
          // For create, send only the base payload (no 'id')
          url = `${this.baseurl}/management/sdv/createsdvplanrule`;
          method = axios.post;
          await method(url, basePayload, this.authHeaders());
          alert("Rule created successfully");
        }

        this.$emit("saved");
        this.closeModal();
      } catch (err) {
        console.error("Error saving rule:", err);
        alert(err.response?.data?.detail || "Save failed");
      }
      finally {
        this.isSubmitting = false;
      }
    },

    //   async submitRule() {
    //   if (!this.validate()) return;

    //   const subjectArray = this.subjectInput
    //     .split(',')
    //     .map(s => s.trim())
    //     .filter(s => s !== '');

    //   const applyTo = this.allSitesSelected ? "AllSites" : "SelectedSites";

    //   const payload = {
    //     studyId: store.getters.getStudyIs,
    //     studyRef: "",
    //     planId: this.planId,
    //     planVersion: this.planVersion,
    //     ruleNo: this.rule.ruleNo || 0,
    //     ruleName: this.rule.ruleName,
    //     ruleType: this.rule.ruleType,
    //     triggerType: this.rule.triggerType,
    //     triggerEvent: this.rule.triggerEvent,
    //     priority: this.rule.priority,
    //     formId: this.rule.formId,
    //     formName: this.rule.formName,
    //     fieldName: this.selectedFields,
    //     fieldLabel: this.selectedFields.map(f => {
    //       const field = this.availableFields.find(x => x.fieldName === f);
    //       return field ? field.label : "";
    //     }),
    //     applyTo: applyTo,
    //     fields: this.selectedFields,
    //     siteIds: this.selectedSites,
    //     visitIds: this.selectedVisits,
    //     subjectId: subjectArray,
    //     triggerConditions: this.triggerConditions,
    //     sdvPercentage: this.rule.sdvPercentage,
    //     status: this.rule.status,
    //     isDeleted: false
    //   };

    //   try {
    //     let url = `${this.baseurl}/management/sdv/createsdvplanrule`; // create
    //     if (this.isEditMode) {
    //       url = `${this.baseurl}/management/sdv/updatesdvplanrule`;
    //       await axios.put(url, payload, this.authHeaders());
    //       alert("Rule updated successfully");
    //     } else {
    //       await axios.post(url, payload, this.authHeaders());
    //       alert("Rule created successfully");
    //     }
    //     this.$emit("saved");
    //     this.closeModal();
    //   } catch (err) {
    //     console.error("Error saving rule:", err);
    //     alert(err.response?.data?.detail || "Save failed");
    //   }
    // },

    clearError(field) {
      this.$set(this.errors, field, false);
      this.$set(this.errorMessages, field, "");
    },

    closeModal() {
      this.$emit("closeModal");
    },
    async getStudyDetails() {
      const studyId = store.getters.getStudyIs;
      const token = store.getters.getIdToken;
      if (!studyId || !token) return;

      try {
        const response = await axios.get(
          `${this.baseurl}/management/study/getbyid?id=${studyId}`,
          {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );
        this.studyRef = response.data?.studyRef || "";
      } catch (error) {
        console.error("Failed to load study details:", error);

      }
    },
    
  }
};